import React from "react";

import { Box, Hidden } from "@material-ui/core";

import { withStyles } from "@material-ui/core/styles";

import MobileContent from "./MobileContent";
import DesktopContent from "./DesktopContent";


const MapContainer = withStyles({
  root: {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
  },
})(Box);

const ContentContainer = withStyles({
  root: {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    pointerEvents: "none",
  },
})(Box);


function DistancingHomeLayout(props) {
  const {
    map,
    selectedDate,
    baselineDate,
  } = props;

  return (
      <>
        <MapContainer>{map}</MapContainer>
        {selectedDate && baselineDate && (
          <ContentContainer>
            <Hidden smUp>
              <MobileContent {...props} />
            </Hidden>
            <Hidden xsDown>
              <DesktopContent {...props} />
            </Hidden>
          </ContentContainer>
        )}
      </>
  );
}

export default DistancingHomeLayout;
